var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 678.13 417.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 678.13,
    height: 417.7,
    fill: "#cddbed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.59,400.85H50.36s35.44-136.46,201.91-215.57c166.47-79.11,334.79-59.81,333.05,25.68-1.45,71.14-44.03,96.3-52.16,127.32-4.7,17.93,1.85,37.26,16.24,48.57,7.69,6.04,28.25,11.5,44.19,14Z",
    fill: "#f4f1ea"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 598.73,
    cy: 337.42,
    r: 29.83,
    fill: "#f4f1ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.6,
    cy: 200.98,
    r: 49.11,
    transform: "translate(-124.66 101.01) rotate(-45)",
    fill: "#f4f1ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.68,
    cy: 20.27,
    r: 7.59,
    transform: "translate(236.87 337.27) rotate(-77.2)",
    fill: "#dbd6c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 657.61,
    cy: 263.34,
    r: 7.59,
    transform: "translate(-50.73 270.35) rotate(-22.39)",
    fill: "#dbd6c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.1,
    cy: 61.27,
    r: 11.68,
    fill: "#f4f1ea"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.58,281.09h21.8c1.84,0,3.33,1.49,3.33,3.33v21.51c0,1.84-1.49,3.33-3.33,3.33H30.52c-2.36,0-4.27-1.91-4.27-4.27v-20.57c0-1.84,1.49-3.33,3.33-3.33Z",
    fill: "#f5d453"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.25,122.77h42.56c1.78,0,3.23,1.45,3.23,3.23v18.3c0,1.78-1.45,3.23-3.23,3.23h-39.33c-1.78,0-3.23-1.45-3.23-3.23v-21.53h0Z",
    transform: "translate(276.29 270.31) rotate(180)",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.04 142.42 161.08 153.36 151.73 142.44 161.04 142.42",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.07,134.87c0,1.04-.84,1.89-1.88,1.89-1.04,0-1.89-.84-1.89-1.88,0-1.04,.84-1.89,1.88-1.89,1.04,0,1.89,.84,1.89,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.16,134.85c0,1.04-.84,1.89-1.88,1.89-1.04,0-1.89-.84-1.89-1.88s.84-1.89,1.88-1.89c1.04,0,1.89,.84,1.89,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,134.82c0,1.04-.84,1.89-1.88,1.89-1.04,0-1.89-.84-1.89-1.88,0-1.04,.84-1.89,1.88-1.89,1.04,0,1.89,.84,1.89,1.88Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 517.32,
    cy: 65.45,
    r: 28.88,
    fill: "#f5d453"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M606.71,148.68h35.82c3.02,0,5.48,2.45,5.48,5.48v35.34c0,3.02-2.45,5.48-5.48,5.48h-34.28c-3.87,0-7.02-3.15-7.02-7.02v-33.8c0-3.02,2.45-5.48,5.48-5.48Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 611.01,
    y1: 171.87,
    x2: 639.15,
    y2: 171.87,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.01,
    y1: 165.38,
    x2: 639.15,
    y2: 165.38,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.01,
    y1: 177.57,
    x2: 622.75,
    y2: 177.57,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.06
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.68,111.6H219.6c-11.73,0-21.24-9.51-21.24-21.24h0c0-1.08,.11-2.13,.26-3.17,1.53-10.22,10.33-18.07,20.97-18.07h196.08v42.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,108.43h0c0,11.73,9.51,21.24,21.24,21.24h196.08v-42.47H236.23c-11.73,0-21.24,9.51-21.24,21.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.36,87.19h.26c-.16,1.04-.26,2.09-.26,3.17v-3.17Z",
    fill: "#fffefc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,108.43h0c0,11.73,9.51,21.24,21.24,21.24h196.08v-42.47H236.23c-11.73,0-21.24,9.51-21.24,21.24Z",
    fill: "none",
    stroke: "#eae6da",
    strokeMiterlimit: 10,
    strokeWidth: 4.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,111.6h232.62V400.85H229.55c-17.23,0-31.19-13.96-31.19-31.19V90.36c0,11.73,9.51,21.24,21.24,21.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,111.6H222.07c-5.56,0-10.69-1.83-14.82-4.92-7.31-5.46-10.75-14.7-9.35-23.72l.47-3.05",
    fill: "none",
    stroke: "#eae6da",
    strokeMiterlimit: 10,
    strokeWidth: 4.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.73,165v-35.86h4.88l19.28,25.03v-25.03h6.05v35.86h-4.83l-19.33-25.13v25.13h-6.05Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29,165v-35.86h23.86v5.19h-17.6v9.87h16.48v5.19h-16.48v10.43h17.6v5.19h-23.86Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.88,165l-12.67-35.86h6.71l8.9,26.45,9.36-26.45h4.83l9.16,26.81,9.16-26.81h6.36l-12.77,35.86h-5.39l-9.11-25.89-9.16,25.89h-5.39Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,165.51c-2.82,0-5.43-.36-7.83-1.09-2.41-.73-4.44-1.72-6.1-2.98l1.98-5.14c1.66,1.19,3.48,2.1,5.47,2.75,1.98,.64,4.15,.97,6.49,.97,2.68,0,4.63-.45,5.85-1.35,1.22-.9,1.83-2.06,1.83-3.48,0-1.19-.43-2.12-1.3-2.8-.87-.68-2.35-1.24-4.45-1.68l-5.6-1.17c-6.38-1.36-9.56-4.63-9.56-9.82,0-2.24,.59-4.19,1.78-5.85,1.19-1.66,2.83-2.95,4.93-3.87s4.53-1.37,7.27-1.37c2.44,0,4.73,.36,6.87,1.09,2.14,.73,3.92,1.75,5.34,3.08l-1.98,4.88c-2.82-2.37-6.24-3.56-10.28-3.56-2.34,0-4.17,.49-5.49,1.48-1.32,.98-1.98,2.27-1.98,3.87,0,1.22,.41,2.2,1.22,2.92,.81,.73,2.2,1.3,4.17,1.7l5.54,1.17c3.36,.71,5.86,1.83,7.5,3.36,1.64,1.53,2.47,3.56,2.47,6.1,0,2.14-.58,4.02-1.73,5.65-1.15,1.63-2.79,2.89-4.91,3.79-2.12,.9-4.62,1.35-7.5,1.35Z",
    fill: "#131200"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226.74,
    y: 181.29,
    width: 194.84,
    height: 43.63,
    rx: 2.68,
    ry: 2.68,
    fill: "#f5d453"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.96,
    y: 244.02,
    width: 72.63,
    height: 72.63,
    rx: 4.15,
    ry: 4.15,
    fill: "#ee707e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 246.87,
    x2: 334.34,
    y2: 246.87,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 261.37,
    x2: 334.34,
    y2: 261.37,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 275.87,
    x2: 334.34,
    y2: 275.87,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 290.37,
    x2: 334.34,
    y2: 290.37,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 304.87,
    x2: 334.34,
    y2: 304.87,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 319.37,
    x2: 334.34,
    y2: 319.37,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 333.87,
    x2: 421.59,
    y2: 333.87,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 348.37,
    x2: 421.59,
    y2: 348.37,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.74,
    y1: 362.88,
    x2: 421.59,
    y2: 362.88,
    fill: "none",
    stroke: "#c5bbba",
    strokeMiterlimit: 10,
    strokeWidth: 2.22
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 450.56,
    y1: 277.18,
    x2: 433.12,
    y2: 400.85,
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "484.53 374.8 437.86 374.8 480.92 349.09",
    fill: "none",
    stroke: "#122335",
    strokeLinejoin: "round",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.66,
    y: 273.29,
    width: 37.73,
    height: 6.59,
    fill: "#122335"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M535.67,280.5l-37.02-41.62-3.17-7.32-11.56,2.19-7.69,37.6,32.65,21.41-30.71,31.1s5.25,26.82,6.21,26.44c.76-.3,36.25-32.64,51.34-46.32,4-3.63,5.82-9.31,4.75-14.82h0c-.65-3.37-2.35-6.42-4.8-8.65Z",
    fill: "#4daf96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "478.44 363.74 482.76 387.24 495.02 388.44 492.1 363.74 478.44 363.74",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.16,384.13l17.53-1.07-.09,6.51s12.91,.51,12.56,10.89h-28.58l-1.42-16.33Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.8,
    y: 397.47,
    width: 29.94,
    height: 2.99,
    fill: "#122335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.6,389.57s-3.43-.68-6.55,.9",
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.08,238.96s-10.07,18.66-.2,57.11l14.6,80.29,21.97-2.1-10.64-141.32-25.73,6.02Z",
    fill: "#4daf96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.52,282.27c-.07-.94-1.34-17.83-1.34-17.83l5.98-15.68",
    fill: "none",
    stroke: "#2e896f",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493.17,
    y1: 308.66,
    x2: 495.53,
    y2: 340.42,
    fill: "none",
    stroke: "#2e896f",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.91,145.24s1.9,14.31-8.86,14.51c-10.76,.2-7.75-15.15-7.75-15.15l16.62,.63Z",
    fill: "#ee707e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.77,156.32c-2.8,0-5.08-2.28-5.08-5.08s2.28-5.08,5.08-5.08,5.08,2.28,5.08,5.08-2.28,5.08-5.08,5.08Zm0-8.54c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z",
    fill: "#ee707e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M557.1,139.97c-.47-.36-.78-.67-1.12-1.06-.32-.39-.61-.82-.85-1.3-.48-.96-.68-2.18-.49-3.35,.19-1.16,.7-2.19,1.3-3.05,.6-.86,1.29-1.6,2-2.24,1.43-1.29,2.96-2.29,4.51-3.19,.39-.23,.78-.45,1.17-.65l1.13-.6c.67-.35,1.33-.71,1.96-1.09,1.26-.75,2.41-1.59,3.31-2.44,.45-.42,.81-.85,1.04-1.23,.24-.37,.31-.69,.23-.76-.07-.09-.29,.22-.32,.51-.04,.3-.05,.41-.23,.34-.17-.07-.49-.25-.9-.45-.42-.2-.93-.41-1.48-.61-3.2-1.2-4.83-4.77-3.63-7.97s4.77-4.83,7.97-3.63c.51,.19,.99,.45,1.42,.75l.24,.17c1.71,1.23,3.52,2.58,5.19,5.01,.8,1.22,1.58,2.8,1.78,4.73,.22,1.9-.25,3.89-1.03,5.26-.76,1.41-1.7,2.4-2.6,3.18-.91,.78-1.82,1.38-2.71,1.88-1.79,.99-3.54,1.66-5.26,2.19-.86,.27-1.72,.5-2.58,.71-.46,.12-.77,.17-1.16,.26-.37,.07-.74,.16-1.1,.25-1.45,.36-2.85,.81-4.08,1.4-1.22,.59-2.25,1.34-2.7,2.16-.22,.41-.33,.89-.25,1.45,.06,.54,.38,1.22,.69,1.68l.11,.17c.35,.5,.22,1.19-.28,1.54-.4,.28-.93,.25-1.3-.03Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M547.23,162.31c-3.06,3.45-8.34,3.76-11.79,.7-3.45-3.06-3.76-8.34-.7-11.79,3.06-3.45,8.34-3.76,11.79-.7,3.45,3.06,3.76,8.34,.7,11.79Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.28,148.45s-1.98-3.26-5.13-.21c-3.15,3.05-5.54,8.72,.29,14.78l4.84-14.57Z",
    fill: "#ffc0bb"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "532.81 153.75 527.82 175.27 537.04 178.62 542.31 162.54 532.81 153.75",
    fill: "#ffc0bb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491.37,174.62l25.45,17.25,5.42-19.59c.72-3.09,4.03-4.79,6.96-3.58l9.88,4.54c2.4,1,3.68,3.63,2.97,6.14l-7.82,27.67c-2.6,9.16-13.3,13.23-21.32,8.1l-22.4-10.61,.86-29.91Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541 168.31 538.92 177.31 526.27 170.91 528.84 162.83 541 168.31",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 539.78,
    y1: 173.6,
    x2: 527.1,
    y2: 168.31,
    fill: "none",
    stroke: "#5287dd",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.97,172.91l-31.72-.37c-5.13,.32-5.97,4.42-5.61,9.36l14.43,57.07,33.4-7.41,.05-50.11c-.78-5.15-5.36-8.85-10.56-8.53Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.53,206.9s.38-19.66-2.64-23.11",
    fill: "none",
    stroke: "#5287dd",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.09,246.06l-8.61,3.41-2.2,13.08s-1.89,6.28-4.9,9.53c-1.91,2.06-8.76,9.8-7.62,12.6,2.11,5.18,11.28-9.22,16.37-8.58,0,0,2.46-.33,3.48,3.57,.21,.8,.74,1.47,1.57,1.43,.82-.04,1.45-.74,1.41-1.55l-.57-13.46,1.08-20.03Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "435.29 253.93 435.93 264.22 448.85 265.77 450.14 259.3 435.29 253.93",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.53,172.53l-7.03,84.09c-.27,1.89-1.99,3.23-3.89,3.03l-14.93-1.34c-2-.22-3.42-2.06-3.12-4.05l8.88-67.45c1.84-11.17,6.05-15.38,16.61-14.28h3.47Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.57,
    y1: 219.84,
    x2: 458.49,
    y2: 196.93,
    fill: "none",
    stroke: "#5287dd",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.57,
    y1: 258.4,
    x2: 449.61,
    y2: 259.65,
    fill: "none",
    stroke: "#5287dd",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 449.63,
    cy: 135.16,
    r: 11.06,
    transform: "translate(128.55 477.71) rotate(-63.58)",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.8,150.24c.18,2.75,2.56,4.83,5.32,4.65s4.83-2.56,4.65-5.32c-.18-2.75-2.56-4.83-5.32-4.65-2.75,.18-4.83,2.56-4.65,5.32Z",
    fill: "#f2a9a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.93,156.5l1.29,16.19c.34,4.55-2.41,5.08-6.39,5.35h0c-3.39,.23-6.37-.7-7.05-4.47l-1.92-17.46,14.06,.39Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.98 169.64 464.11 160.59 476.24 160.38 476.98 169.64",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.27,163.33l4.67-.31c5.23-.35,10.57-3.73,10.27-10.54l-.68-12.17c-.65-6.39-6.36-11.12-12.92-10.68h0c-6.71,.45-12.97,6.22-12.53,12.78l1.64,13.17c.55,4.67,4.75,8.08,9.54,7.76Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.86,146.38c.09,.69-.4,1.32-1.09,1.41-.69,.09-1.32-.4-1.41-1.09-.09-.69,.4-1.32,1.09-1.41,.69-.09,1.32,.4,1.41,1.09Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.63,145.35c.08,.61-.35,1.17-.96,1.25-.61,.08-1.17-.35-1.25-.96-.08-.61,.35-1.17,.96-1.25,.61-.08,1.17,.35,1.25,.96Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "479.15 147.44 480.34 150.29 478.47 151.16",
    fill: "none",
    stroke: "#e08d8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.26,142.33s-2.75,.57-2.43,1.42c.32,.85,3.59,0,3.59,0,0,0,2.21-.58,1.97-1.55-.12-.5-3.13,.13-3.13,.13Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.29,141.21s2.48-.02,2.39,.88c-.1,.9-3.09,.75-3.09,.75,0,0-2.02-.1-2.02-1.1,0-.52,2.72-.53,2.72-.53Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.04,152.8s1.95,2.05,5.7,.93",
    fill: "none",
    stroke: "#131200",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.84
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.79,151.25s7.36-5.69,3.14-13.64c0,0,13.08,3.19,19.74-.71,0,0-1.25-10.79-17.52-8.04-17.62,2.98-9.9,19.57-9.9,19.57l4.55,2.82Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M454.16,152.5c.18,2.75,2.56,4.83,5.32,4.65,2.75-.18,4.83-2.56,4.65-5.32s-2.56-4.83-5.32-4.65c-2.75,.18-4.83,2.56-4.65,5.32Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.98,153.53s-.24-3.61-3.66-2.81",
    fill: "none",
    stroke: "#e08d8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.84
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 125.33,
    y1: 327.09,
    x2: 107.63,
    y2: 400.85,
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.88,
    y1: 327.09,
    x2: 171.59,
    y2: 400.85,
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.85,
    y1: 327.09,
    x2: 138.85,
    y2: 400.36,
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.46,
    y: 323.16,
    width: 52.79,
    height: 6.14,
    fill: "#122335"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "196.2 354.85 198.52 387.93 210.78 389.13 212.64 353.6 196.2 354.85",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.92,384.83l17.53-1.07-.09,6.51s15.05,.51,14.7,10.89h-32.86l.72-16.33Z",
    fill: "#4daf96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.43,
    y: 398.16,
    width: 34.21,
    height: 2.99,
    fill: "#122335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,390.27s-3.43-.68-6.55,.9",
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M191.19,317.53v57.77h27.79v-63.88c0-10.07-8.16-18.23-18.23-18.23h-30.72l21.16,24.34Z",
    fill: "#79a5fc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "152.81 344.96 131.55 370.41 139.55 379.78 165.52 355.45 152.81 344.96",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.55,367.06l13.38,11.38-4.58,4.63s10.49,10.8,3.05,18.04l-23.69-22.78,11.83-11.27Z",
    fill: "#4daf96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.55,
    y: 387.14,
    width: 34.05,
    height: 2.99,
    transform: "translate(306.67 15.91) rotate(43.88)",
    fill: "#122335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.35,383.08s-2-2.87-5.34-3.89",
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.98,293.2s-2.02,4.57-2.17,10.37c-.27,10.63,8.46,19.32,19.09,19.32h22.68l-29.98,34.47,22.64,16.19,43.29-49.03c9.18-13.23-.29-31.33-16.39-31.33h-59.16Z",
    fill: "#79a5fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14,303.13s8.8,13.72-6.95,27.43",
    fill: "none",
    stroke: "#4e85dd",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.32,230.9c10.73,4.99,15.58,40.25,15.58,40.25,1.8,4.05,1,8.78-2.03,12.02h0c-4.81,5.13-13.2,4.56-17.12-1.28-2.52-3.76-9.09-14.76-10.99-20.75l14.56-30.24Z",
    fill: "#f8cf63"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.43,237.6s1.9,14.31-8.86,14.51-7.75-15.15-7.75-15.15l16.62,.63Z",
    fill: "#ee707e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,248.68c-2.8,0-5.08-2.28-5.08-5.08s2.28-5.08,5.08-5.08,5.08,2.28,5.08,5.08-2.28,5.08-5.08,5.08Zm0-8.54c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z",
    fill: "#ee707e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.4,262.83c-5.01,3-11.51,1.37-14.51-3.64-3-5.01-1.37-11.51,3.64-14.51,5.01-3,11.51-1.37,14.51,3.64,3,5.01,1.37,11.51-3.64,14.51Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.27,243.45s-1.15-4.68-6.11-2.21c-4.97,2.48-10.01,8.42-5.27,17.95l11.39-15.75Z",
    fill: "#ffc0bb"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195.38,267.31l37.47-17.36,9.32,15.34-36.02,19.64c-6.18,4.13-14.57,.59-15.91-6.73h0c-.8-4.36,1.27-8.75,5.14-10.9Z",
    fill: "#f8cf63"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.66,224.59l-17.73,.78s-18.86,14.69-30.02,71.17l58.6-5.82s23.73-46.16,5.74-62.58l-16.6-3.56Z",
    fill: "#f8cf63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,277.76s5.98-13.42,5.98-29.64",
    fill: "none",
    stroke: "#e0b044",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.32 230.9 181.79 224.92 184.77 238.03 193.96 238.03 194.32 230.9",
    fill: "#f8cf63"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.17,287.63s20.86,.18,15.97,15.51h-27.49l11.52-15.51Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.1,284.3l17.49-41.34c2.1-4.97,.85-10.72-3.12-14.38h0c-5.97-5.49-15.48-4.11-19.61,2.87-7.85,13.27-19.08,35-24.1,57.86h0c-1.14,7.48,4.68,14.21,12.25,14.16l43.05-.29,8.7-18.88h-34.66Z",
    fill: "#f8cf63"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "165.25 248.49 150.1 284.3 184.77 284.3",
    fill: "none",
    stroke: "#e0b044",
    strokeMiterlimit: 10,
    strokeWidth: 1.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.94,183.13s-19.42-8-17.98,14.66l18.94-10.52-.96-4.15Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.31,
    cy: 208.98,
    r: 5.06,
    transform: "translate(-70.2 106.61) rotate(-25.41)",
    fill: "#f2a9a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.89,214.26l-5.29,15.93c-1.64,4.8-5.05,4.02-9.77,2.37h0c-4.03-1.41-7.06-3.79-6.16-7.96l5.13-17.53,16.09,7.19Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.26 228.15 178.81 214.08 191.54 218.36 188.26 228.15",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55,218.28l6.68,2.34c5.02,1.75,10.49-1,12.08-6.07l3.87-12.54c1.99-6.36-1.42-13.15-7.71-15.35h0c-6.44-2.25-14.61,.75-16.86,7.19l-3.81,13.22c-1.38,4.67,1.15,9.6,5.75,11.21Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.72,205.82c-.18,.63-.84,1-1.47,.82-.63-.18-1-.84-.82-1.47,.18-.63,.84-1,1.47-.82s1,.84,.82,1.47Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,208.57c-.16,.56-.74,.89-1.3,.73-.56-.16-.89-.74-.73-1.3,.16-.56,.74-.89,1.3-.73,.56,.16,.89,.74,.73,1.3Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.87 208.68 196.73 212.05 194.52 211.97",
    fill: "none",
    stroke: "#e08d8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.28,202.13c-.21-.03-.41-.14-.56-.32-.05-.06-.84-.97-2.83-.55-.46,.1-.91-.2-1.01-.65-.1-.46,.19-.91,.65-1.01,3.14-.67,4.49,1.12,4.55,1.19,.28,.38,.2,.91-.18,1.19-.19,.14-.41,.19-.62,.16Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,204.64c-.21-.03-.41-.14-.55-.31-.46-.57-1.58-.46-1.59-.46-.47,.05-.89-.28-.94-.74-.06-.46,.27-.89,.73-.95,.21-.03,2.09-.23,3.13,1.09,.29,.37,.23,.9-.14,1.19-.19,.15-.42,.21-.65,.18Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08,210.77s1.28,3.32,5.25,3.55",
    fill: "none",
    stroke: "#131200",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.68
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,202l2.53-.41c.87-2.34,2.82-8,5.17-8.82,4.06-1.4,10.51-.97,17.73,5.38,0,0,1.13-10.48-8.86-14.16-9.98-3.68-19.9,5.02-20.72,9.45-.82,4.43,4.14,8.56,4.14,8.56Z",
    fill: "#131200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.95,200.23c-.92,2.64,.47,5.53,3.11,6.45s5.53-.47,6.45-3.11-.47-5.53-3.11-6.45c-2.64-.92-5.53,.47-6.45,3.11Z",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,203.91s1.21-3.47-2.29-4.08",
    fill: "none",
    stroke: "#e08d8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,192.77s4.2-.24,8.62,3.36c5.84,4.76,20.7,5.58,15.72-6.97-4.48-11.27-25.63-6.82-26.39-5.67s2.05,9.28,2.05,9.28Z",
    fill: "#131200"
  })))), /*#__PURE__*/React.createElement("line", {
    x1: 21.08,
    y1: 400.85,
    x2: 622.6,
    y2: 400.85,
    fill: "none",
    stroke: "#122335",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.490bba8ba902118f826c4454865fe309.svg";
export { ForwardRef as ReactComponent };